import { HTTP, authHeader } from './http-service';

class ComplaintTriageSearchService {
  search(payload) {
    return HTTP.post(`/ComplaintTriageSearch`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  advancedSearch(payload) {
    return HTTP.post(`/ComplaintTriageSearch/advance`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getComplaintTriageStatusesCount() {
    return HTTP.post(`/ComplaintTriageSearch/complaintTriageStatusesCount`, {
      headers: authHeader(),
    }).then((response) => response.data.model);
  }
}

export default new ComplaintTriageSearchService();
